import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
  const [popularNews, setPopularNews] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('https://dsdspl.com/api/panchyat-api/public/api/index')
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 'success' && data.data) {
          const newsData = data.data.slice(0, 6).map((item) => ({
            description: item.short_description,
            imageUrl: item.image,
            link: item.id,
          }));
          setPopularNews(newsData);

          const categoriesData = data.data.slice(0, 6).map((item) => ({
            cetegorieName: item.cetegorieName,
            link: item.link,
          }));
          setCategories(categoriesData);
        }
      })
      .catch((error) => console.error('Error fetching data:', error));
  }, []);

  const handleCategoryClick = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
  };

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setShowModal(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setShowModal(false);
    document.body.style.overflow = 'unset';
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) =>
      prev === popularNews.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) =>
      prev === 0 ? popularNews.length - 1 : prev - 1
    );
  };

  return (
    <>
      <div className="container-fluid bg-dark pt-5 px-sm-3 px-md-5 mt-5">
        <div className="row py-4">
          <div className="col-lg-4 col-md-6 mb-5">
            <h5 className="mb-4 text-white text-uppercase font-weight-bold" style={{ fontSize: '16px' }}>संपर्क करें</h5>
            <img src="logo.png" alt="" className="mb-4" style={{ maxWidth: '200px' }} />
            <div className="text-white ">
              <div className="d-flex mb-2 mt-2" style={{ fontSize: '14px' }}>
                <span className="text-white" style={{ minWidth: '80px' }}>Address 1 :</span>
                <span>F-32, Adarsh Marg, Sarvodaya Nagar, Lucknow-226016, U.P</span>
              </div>
              <div className="d-flex mb-2 mt-2" style={{ fontSize: '14px' }}>
                <span className="text-white" style={{ minWidth: '80px' }}>Address 2 :</span>
                <span>B-4/91, Vineet Khand, Gomti Nagar, Lucknow-226010, U.P</span>
              </div>
              <div className="d-flex mb-2 mt-2" style={{ fontSize: '14px' }}>
                <span className="text-white" style={{ minWidth: '80px' }}>Contact :</span>
                <span>9792531351</span>
              </div>
              <div className="d-flex mb-2 mt-2" style={{ fontSize: '14px' }}>
                <span className="text-white" style={{ minWidth: '80px' }}>Mail Us :</span>
                <span>panchayatkhabarindia@gmail.com</span>
              </div>
              <div className="d-flex mb-2 mt-3">
                <span>Connect With Us: </span>
                <a href="https://www.facebook.com/profile.php?id=100082809802675" className="me-2" target="_blank">
                  <i style={{ color: 'blue', marginLeft: '20px', fontSize: '30px' }} className="fab fa-facebook"></i>
                </a>

                {/* Twitter Icon */}

                {/* X (formerly Twitter) Icon */}
                <a href="https://x.com/KhabarPanchayat" className="me-2" target="_blank">
                  <i style={{ color: 'black', fontSize: '30px' }} className="fas fa-times"></i>
                </a>




                <a href="https://www.instagram.com/panchayat_khabar/?hl=en" className="me-2" target="_blank">

                  <i
                    className="fab fa-instagram"
                    style={{
                      background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      fontSize: '30px', // Adjust size as needed
                    }}
                  ></i>
                </a>

                <a href="https://www.youtube.com/@PANCHAYAT_KHABAR" className="me-2" target="_blank">
                  <i className="fab fa-youtube " style={{ color: 'red', fontSize: '30px' }}></i>
                </a>
              </div>
            </div>
          </div>




          <div className="col-lg-4 col-md-6 mb-5">
            <h5 className="mb-4 text-white text-uppercase font-weight-bold">कैटेगरी</h5>
            <div className="m-n1">
              <button onClick={() => handleCategoryClick('/Editoal')} className="btn btn-sm btn-secondary m-1">सम्पादकीय</button>
              <button onClick={() => handleCategoryClick('/Khel')} className="btn btn-sm btn-secondary m-1">खेल जगत</button>
              <button onClick={() => handleCategoryClick('/Study')} className="btn btn-sm btn-secondary m-1">शिक्षा</button>
              <button onClick={() => handleCategoryClick('/Study')} className="btn btn-sm btn-secondary m-1">जॉब</button>
              <button onClick={() => handleCategoryClick('/Health')} className="btn btn-sm btn-secondary m-1">स्वास्थ्य</button>
              <button onClick={() => handleCategoryClick('/Bussiness')} className="btn btn-sm btn-secondary m-1">कारोबार</button>
              <button onClick={() => handleCategoryClick('/Lokshbha')} className="btn btn-sm btn-secondary m-1">आवरण कथा - लोकसभा पंचायत</button>
              <button onClick={() => handleCategoryClick('/Vidhanshbha')} className="btn btn-sm btn-secondary m-1">आवरण कथा - विधानसभा पचायत</button>
              <button onClick={() => handleCategoryClick('/Desh')} className="btn btn-sm btn-secondary m-1">इंटरव्यू - देश</button>
              <button onClick={() => handleCategoryClick('/Videsh')} className="btn btn-sm btn-secondary m-1">इंटरव्यू - विदेश</button>
              <button onClick={() => handleCategoryClick('/Filmi')} className="btn btn-sm btn-secondary m-1">फ़िल्मी सितारे</button>
              <button onClick={() => handleCategoryClick('/Lagukatha')} className="btn btn-sm btn-secondary m-1">लघुकथा</button>
              <button onClick={() => handleCategoryClick('/Astrology')} className="btn btn-sm btn-secondary m-1">ज्योतिषी</button>
              <button onClick={() => handleCategoryClick('/Krishi')} className="btn btn-sm btn-secondary m-1">कृषि पंचांग</button>
              <button onClick={() => handleCategoryClick('/Beuty')} className="btn btn-sm btn-secondary m-1">ब्यूटी व फैशन</button>
              <button onClick={() => handleCategoryClick('/Khabar')} className="btn btn-sm btn-secondary m-1">खोज ख़बर</button>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-5">
            <h5 className="mb-4 text-white text-uppercase font-weight-bold">गैलरी</h5>
            <div className="row popimg">
              {popularNews.map((news, index) => (
                <div key={index} className="col-4 mb-3">
                  <div
                    onClick={() => openModal(index)}
                    style={{ cursor: 'pointer' }}
                  >
                    <img
                      className="w-100"
                      src={`https://dsdspl.com/api/panchyat-api/public/${news.imageUrl}`}
                      alt={`Gallery Image ${index + 1}`}
                      style={{ height: '100px', objectFit: 'cover' }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div >
      </div >

      {showModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 50,
            padding: '20px'
          }}
          onClick={closeModal}
        >
          <div
            className="relative"
            style={{ position: 'relative', maxWidth: '100%' }}
            onClick={e => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-white"
              style={{
                position: 'absolute',
                top: '8px',
                right: '8px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                zIndex: 51
              }}
            >
              <i className="fa fa-times" style={{ fontSize: '24px', color: 'white' }}></i>
            </button>

            <img
              src={`https://dsdspl.com/api/panchyat-api/public/${popularNews[currentImageIndex]?.imageUrl}`}
              alt={`Gallery Image ${currentImageIndex + 1}`}
              style={{
                maxWidth: '100%',
                width: '600px',
                height: '500px',
                objectFit: 'contain',
                '@media (max-width: 768px)': {
                  width: '300px',
                  height: '300px'
                }
              }}
            />

            <button
              onClick={prevImage}
              className="absolute left-2 top-1/2 transform -translate-y-1/2"
              style={{
                position: 'absolute',
                left: '8px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                zIndex: 51
              }}
            >
              <i className="fa fa-chevron-left" style={{ fontSize: '32px', color: 'white' }}></i>
            </button>

            <button
              onClick={nextImage}
              className="absolute right-2 top-1/2 transform -translate-y-1/2"
              style={{
                position: 'absolute',
                right: '8px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                zIndex: 51
              }}
            >
              <i className="fa fa-chevron-right" style={{ fontSize: '32px', color: 'white' }}></i>
            </button>
          </div>
        </div>
      )}

      <div className="container-fluid py-4 px-sm-3 px-md-5" style={{ background: '#111111' }}>
        <p className="m-0 text-center">
          © {new Date().getFullYear()} <a href="https://panchayatkhabar.co.in/">Panchayat Khabar</a>.
          All Rights Reserved. Developed By - <a href="https://dsdspl.com/" target="_blank" rel="noopener noreferrer">Dsd Systems Pvt. Ltd.</a>
        </p>
      </div>

      <a href="#" className="btn btn-primary border-2 border-white rounded-circle back-to-top">
        <i className="fa fa-arrow-up"></i>
      </a>
    </>
  );
};

export default Footer;